import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CustomMentionsComponent from 'components/form-components/CustomMentionsComponent';

function OtpMessage({ fieldSectionProperties, toggleBox, onChangeProperties }) {
  const { t } = useTranslation();
  const [resetMentionsInput, setResetMentionsInput] = useState(false);

  const systemElementsHeadingArray = [
    {
      id: 'Please-select-contents:',
      display: t('form_field_watermark_dropdown_Please select contents'),
      value: 'Please-select-contents:',
      type: 'heading',
    },
    {
      id: 'options:',
      display: t('form_field_watermark_dropdown_options'),
      value: 'options:',
      type: 'heading',
    },
  ];
  const systemElementsOptionArray = [
    {
      id: 'user-name',
      display: t('form_field_watermark_dropdown_User Name'),
      value: 'user-name',
      type: 'systemField',
    },
    {
      id: 'company-name',
      display: t('form_field_otp_content_dropdown_company_name'),
      value: 'company-name',
      type: 'systemField',
    },
    {
      id: 'otp-code',
      display: t('form_field_otp_content_dropdown_otp'),
      value: 'otp-code',
      type: 'systemField',
    },
  ];

  const updateMentionsMap = (updatedObject) => {
    fieldSectionProperties.otpMessageContentMap = { ...updatedObject };
  };

  return (
    <div>
      <div className='d-flex justify-content-between align-items-baseline'>
        <span className='theme-size-0_8'>{t('form_field_otp_message_title')}</span>
        <span
          className={`user-select-none ${
            fieldSectionProperties['otpMessageContent']
              ? 'theme-text-green-1 cursor-pointer'
              : 'text-secondary opacity-50'
          }`}
          onClick={() =>
            fieldSectionProperties['otpMessageContent'] && setResetMentionsInput((prev) => !prev)
          }
        >
          {t('text_reset')}
        </span>
      </div>
      <CustomMentionsComponent
        name={'otpMessageContent'}
        placeholder={t('form_field_otp_message_placeholder_text')}
        value={fieldSectionProperties['otpMessageContent']}
        handleChange={(name, value) => {
          onChangeProperties(name, value, toggleBox.defaultPropsKey + 'Properties');
        }}
        updateMentionsMap={updateMentionsMap}
        resetMentionsInput={resetMentionsInput}
        setResetMentionsInput={setResetMentionsInput}
        systemElementsHeadingArray={systemElementsHeadingArray}
        systemElementsOptionArray={systemElementsOptionArray}
      />
    </div>
  );
}
OtpMessage.propTypes = {
  fieldSectionProperties: PropTypes.object,
  toggleBox: PropTypes.object,
  onChangeProperties: PropTypes.func,
};
export default OtpMessage;
